import { useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  const [key, setKey] = useState("");
  const [enquiries, setEnquiries] = useState(null);
  const [reviews, setReviews] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const headers = { "X-Admin-Key": key };
      const [enq, rev] = await Promise.all([
        axios.get(`${API}/enquiries`, { headers }),
        axios.get(`${API}/reviews/all`, { headers }),
      ]);
      setEnquiries(enq.data);
      setReviews(rev.data);
    } catch (err) {
      setError("Wrong password.");
      setEnquiries(null);
    } finally {
      setLoading(false);
    }
  };

  const approve = async (id) => {
    await axios.patch(`${API}/reviews/${id}/approve`, {}, { headers: { "X-Admin-Key": key } });
    load();
  };

  return (
    <div data-testid="admin-page" className="min-h-screen bg-[#050505] px-5 py-16 text-[#F3F3F5] sm:px-10">
      <div className="mx-auto max-w-4xl">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.3em]">JW. EDITS</p>
        <h1 className="mt-4 font-display text-4xl font-black uppercase tracking-tight sm:text-6xl">
          STUDIO INBOX
        </h1>

        {enquiries === null ? (
          <form onSubmit={load} className="mt-12 flex max-w-md gap-3">
            <input
              data-testid="admin-password-input"
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="ADMIN PASSWORD"
              className="flex-1 border border-white/15 bg-transparent px-4 py-3 text-sm outline-none placeholder:text-[#3a3a3f] focus:border-[#E63946]"
            />
            <button
              data-testid="admin-login-button"
              type="submit"
              disabled={loading}
              className="bg-[#F3F3F5] px-6 py-3 font-mono text-xs uppercase tracking-[0.25em] text-[#050505] transition-colors hover:bg-[#E63946] hover:text-white disabled:opacity-50"
            >
              {loading ? "..." : "VIEW"}
            </button>
          </form>
        ) : (
          <>
            <h2 className="mt-16 font-mono text-xs uppercase tracking-[0.3em] text-[#8E8E93]">
              REVIEWS — APPROVE TO PUBLISH
            </h2>
            <div data-testid="admin-review-list" className="mt-6 space-y-px">
              {reviews.length === 0 && (
                <p className="border border-white/10 p-8 font-mono text-xs uppercase tracking-[0.3em] text-[#8E8E93]">
                  NO REVIEWS YET.
                </p>
              )}
              {reviews.map((r) => (
                <div key={r.id} data-testid={`admin-review-${r.id}`} className="border border-white/10 p-6">
                  <div className="flex flex-wrap items-baseline justify-between gap-2">
                    <h3 className="font-display text-2xl font-black uppercase">{r.name}</h3>
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8E8E93]">
                      {"★".repeat(r.rating)} — {r.project_type || "EDIT"}
                    </span>
                  </div>
                  <p className="mt-3 border-l-2 border-[#E63946] pl-4 text-sm italic text-[#F3F3F5]">
                    "{r.text}"
                  </p>
                  <div className="mt-4">
                    {r.approved ? (
                      <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#4CAF50]">
                        LIVE ON SITE
                      </span>
                    ) : (
                      <button
                        data-testid={`admin-approve-${r.id}`}
                        onClick={() => approve(r.id)}
                        className="bg-[#F3F3F5] px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#050505] transition-colors hover:bg-[#E63946] hover:text-white"
                      >
                        APPROVE
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <h2 className="mt-16 font-mono text-xs uppercase tracking-[0.3em] text-[#8E8E93]">
              PROJECT ENQUIRIES (FORM REMOVED — ARCHIVE ONLY)
            </h2>
            <div data-testid="admin-enquiry-list" className="mt-6 space-y-px">
              {enquiries.length === 0 && (
                <p className="border border-white/10 p-8 font-mono text-xs uppercase tracking-[0.3em] text-[#8E8E93]">
                  NO ENQUIRIES.
                </p>
              )}
              {enquiries.map((q) => (
                <div key={q.id} data-testid={`admin-enquiry-${q.id}`} className="border border-white/10 p-6">
                  <div className="flex flex-wrap items-baseline justify-between gap-2">
                    <h3 className="font-display text-2xl font-black uppercase">{q.name}</h3>
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#8E8E93]">
                      {new Date(q.created_at).toLocaleString()}
                    </span>
                  </div>
                  <div className="mt-3 grid grid-cols-1 gap-2 font-mono text-[11px] uppercase tracking-[0.15em] text-[#8E8E93] sm:grid-cols-2">
                    <span>PHONE — {q.contact}</span>
                    <span>TYPE — {q.video_type}</span>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {error && (
          <p data-testid="admin-error-message" className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-[#E63946]">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
